import axios from 'axios'
import message from '@/utils/message'
import router from '@/router'
import { getToken, removeToken } from '@/utils/auth'

export const API_BASE_URL = '/api'

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000
})

function redirectToNotFound(config) {
  if (!String(config?.url || '').startsWith('/portal/')) {
    return false
  }
  if (router.currentRoute.value.name !== 'PortalNotFound') {
    void router.replace({ name: 'PortalNotFound' })
  }
  return true
}

function redirectToLogin() {
  removeToken()
  const { fullPath } = router.currentRoute.value
  if (!fullPath.startsWith('/admin/login')) {
    void router.push({ path: '/admin/login', query: { redirect: fullPath } })
  }
}

export async function createFetchError(response, fallback = '请求失败') {
  const body = await response.text()
  let messageText = body
  if (body) {
    try {
      const payload = JSON.parse(body)
      messageText = payload.message || payload.error || body
    } catch {
      // 非 JSON 错误响应直接使用原始文本。
    }
  }
  if (response.status === 401) {
    redirectToLogin()
  }
  const error = new Error(messageText || `${fallback}（${response.status}）`)
  error.status = response.status
  return error
}

service.interceptors.request.use((config) => {
  const token = getToken()
  const url = config.url || ''
  if (token && url.startsWith('/admin') && !url.startsWith('/admin/login')) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 404 && redirectToNotFound(response.config)) {
        return Promise.reject(new Error(res.message || '页面不存在'))
      }
      if (res.code === 401) {
        redirectToLogin()
      }
      message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res.data
  },
  (error) => {
    const status = error.response?.status
    const messageText = error.response?.data?.message || error.message || '网络错误'
    error.message = messageText
    if (status === 404 && redirectToNotFound(error.config)) {
      return Promise.reject(error)
    }
    if (status === 401) {
      redirectToLogin()
    }
    message.error(messageText)
    return Promise.reject(error)
  }
)

export default service
